/** An ISO 3166-1 alpha-2 code as its flag emoji (Regional Indicator letters): `bh` → 🇧🇭. */
export function ccToFlag(cc: string): string {
  return [...cc.toUpperCase()].map((c) => String.fromCodePoint(c.charCodeAt(0) + 127397)).join('');
}
